<template>
  <div>
    <div class="flex border-b border-gray-200">
      <button
        v-for="(tab, index) in tabs"
        :key="index"
        @click="activeTab = index"
        :class="{
          'bg-gray-700 text-white text-lg rounded-md': activeTab === index,
          '': activeTab !== index
        }"
        class="px-4 py-3 w-full  -mb-px font-semibold border-b-2 transition duration-300 ease-in-out"
      >
        {{ tab.name }}
      </button>
    </div>
    <div class="p-4">
      <component :is="tabs[activeTab].component"></component>
    </div>
  </div>
</template>

<script setup lang="ts">
import ExportMarkBook from './ExportMarkBook.vue';
import ImportMarkBook from './ImportMarkBook.vue';

// Define the tabs
const tabs = ref([
  { name: 'Export MarkBook', component: ExportMarkBook },
  { name: 'Import MarkBook', component: ImportMarkBook },
]);

// Define the active tab
const activeTab = ref(0);
</script>

<style scoped>
/* Add custom styles if needed */
</style>
